import { SensorData } from 'Simulations/SensorPoint';
import type { StageContext } from '../../Context';
import { FilterStage, StageParameters } from '../../Stage';

export type ValueStageParameters = StageParameters & {
    thresholdRange: [number, number];
};

class ValueThresholdStage extends FilterStage<ValueStageParameters> {
    minValue: number = 0;
    maxValue: number = Infinity;

    protected override processAll(context: StageContext): StageContext {
        this.computeData(context.sensors);
        const outputSensors = context.sensors.map((sensorData) => this.process(sensorData, context)).filter((sd) => sd !== null);
        return { ...context, sensors: outputSensors };
    }

    protected filter(sensorData: SensorData): boolean {
        const slideRange = this.maxValue - this.minValue;

        const minThresholdValue = this.minValue + (this.getParams().thresholdRange[0] / 100) * slideRange;
        const maxThresholdValue = this.minValue + (this.getParams().thresholdRange[1] / 100) * slideRange;
        const epsilon = 1e-9;
        const low = Math.min(minThresholdValue, maxThresholdValue) - epsilon;
        const high = Math.max(minThresholdValue, maxThresholdValue) + epsilon;

        const value = sensorData.getScalarValue();
        return value >= low && value <= high;
    }

    private computeData(sensorData: SensorData[]): void {
        this.minValue = sensorData[0].getScalarValue();
        this.maxValue = sensorData[sensorData.length - 1].getScalarValue();
    }
}

export default ValueThresholdStage;
